import { render } from "./NouveauClient.vue?vue&type=template&id=40831832&scoped=true"
import script from "./NouveauClient.vue?vue&type=script&lang=js"
export * from "./NouveauClient.vue?vue&type=script&lang=js"

import "./NouveauClient.vue?vue&type=style&index=0&id=40831832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40831832"]])

export default __exports__